var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEhIconLocations = function SvgEhIconLocations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.753 1A6.755 6.755 0 0 0 3 7.753c0 2.709.95 3.483 6.05 10.904a.893.893 0 0 0 1.407 0c5.1-7.421 6.05-8.195 6.05-10.904A6.755 6.755 0 0 0 9.753 1m0 9.567A2.82 2.82 0 0 1 6.94 7.753 2.82 2.82 0 0 1 9.753 4.94a2.82 2.82 0 0 1 2.814 2.814 2.82 2.82 0 0 1-2.814 2.814"
  })));
};
export default SvgEhIconLocations;